<p-sidebar [(visible)]="visibleTransactionsFilter"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'640px'}">
    <ng-template pTemplate="header">
        <div class="user-filter-header">
            Update Status
        </div>
    </ng-template>
    <div>
        <p-toast></p-toast>

        <p-scrollPanel [style]="{height: 'calc(100vh - 190px)'}">
            <div class="user-filter-title">
                Upload Excel File (*.xlsx)
            </div>

            <div class="cp-upload-description-block">
                <div class="flex flex-row">
                    <input maxlength="0"
                           pInputText type="text"
                           (click)="handleInputClick('idFileInput')"
                           class="p-inputtext-sm create-product-input-field"
                           placeholder="Upload Excel file" />
                    <p-button icon="pi pi-upload" (click)="handleInputClick('idFileInput')"></p-button>
                </div>

                <input id="idFileInput"
                       type="file"
                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                       style="display: none"
                       (change)="handleXlsChange($event)" required />
            </div>
        </p-scrollPanel>
    </div>
</p-sidebar>